import { gql } from 'graphql-tag';

/**
 * GraphQL mutation to generate a presigned URL for S3 file upload
 */
export const GENERATE_PRESIGNED_URL = gql`
  mutation GeneratePresignedUrl($input: PresignedUrlInput!) {
    generatePresignedUrl(input: $input) {
      url
    }
  }
`;
